import { store } from "services/redux/store";
import { SHOW_HIDE_TOAST } from "../appNotifications/type";
import { CURRENT_LOCATION } from "./type";
import Config from "services/config/config";
import axios from "../../../interceptor/Interceptor";

export const getCurrentLocation = (currentLocation) => async (dispatch) => {
  let url2;
  url2 = Config.profileUrl.saveLocation;
  const payload = {
    query_search: currentLocation,
    module: 'getCurrentLocation API'
  };
  await axios.post(url2, payload);

  let url = `${Config.googleAPI.geocode}json?address=${currentLocation}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;
  fetch(url, {
    method: "POST",
  })
    .then((res) => res.json())
    .then((data) => {
      let lat = "";
      let lng = "";
      const { location } = data.results[0].geometry;
      if (location) {
        lat = location.lat.toFixed(3);
        lng = location.lng.toFixed(3);
      }
      dispatch({
        type: CURRENT_LOCATION,
        lat: lat,
        lng: lng,
        address: data.results[0].formatted_address,
      });
    })
    .catch((error) => {
      dispatch({
        type: CURRENT_LOCATION,
        lat: null,
        lng: null,
        address: null,
      });
      store.dispatch({
        type: SHOW_HIDE_TOAST,
        payload: { isToast: true, toastMessage: "Location not Found!" },
      });
    });
};
